import React, { useState } from "react";
import { useSelector } from "react-redux";
import Moment from "moment";
import { makeStyles, Grid } from "@material-ui/core";
import { Select, Typography, Page } from "@packages/ui";
import DownloadButtonGrid from "src/layouts/DashboardLayout/DownloadButtonGrid";
import * as constants from "../../utils/constants";
import { useCurrentRental } from "src/hooks/rentalHooks";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 15,
    paddingBottom: theme.spacing(3),
  },
}));

const TaxInvoice = () => {
  const classes = useStyles();
  const rentals = useSelector((state) => ({ ...state.app.rentals }));
  const currentRental = useCurrentRental();
  const [raNumber, setRaNumber] = useState(currentRental?.rental_agreement_number);
  const pickUpDate = currentRental?.pickup ? currentRental.pickup.dateTime : "No Date Data";
  const fileName = "rental_invoice";

  function handleSelectClick(e) {
    setRaNumber(e.target.value);
  }

  return (
    <Page className={classes.root} title="Tax Invoice - My Journey Portal">
      <Grid container direction="row">
        <Grid item xs={12}>
          <Typography variant={"h1"} style={{ marginBottom: 30 }}>
            Tax Invoice
          </Typography>
        </Grid>
        <Grid item xs={12}>
          {currentRental?.rental_invoice ? (
            <div>
              <Typography style={{ marginBottom: 30 }}>
                Your tax invoice is available. Select from one of the options below.{" "}
                {currentRental?.brand === "Hertz" ? (
                  <span>
                    <br />
                    <br />
                    Or click{" "}
                    <a
                      href={constants.HERTZ_INVOICE_EXPLAINED}
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: "rgb(66, 139, 255)" }}
                    >
                      here
                    </a>{" "}
                    to see your tax invoice explained.
                  </span>
                ) : (
                  ""
                )}
              </Typography>

              <Grid container spacing={1}>
                <Grid item>
                  <Select
                    title={`${raNumber} - ${Moment(pickUpDate, "YYYY-MM-DD hh:mm").format(
                      "DD/MM/YYYY"
                    )}`}
                    value={raNumber}
                    onChange={(e) => handleSelectClick(e)}
                    options={Object.keys(rentals).map((key) =>
                      rentals[key].rental_invoice
                        ? {
                            value: rentals[key]?.rental_agreement_number,
                            title: rentals[key]?.pickup
                              ? `${rentals[key]?.rental_agreement_number} - ${Moment(
                                  rentals[key]?.pickup.dateTime,
                                  "YYYY-MM-DD hh:mm"
                                ).format("DD/MM/YYYY")}`
                              : `${rentals[key]?.rental_agreement_number} - No Pickup Data`,
                          }
                        : {
                            value: 0,
                            title: `${rentals[key]?.rental_agreement_number} - No Tax Invoice`,
                          }
                    )}
                  ></Select>
                </Grid>
                <DownloadButtonGrid raNumber={raNumber} fileName={fileName} fileLabel="Tax Invoice" />
              </Grid>
            </div>
          ) : (
            <Typography style={{ marginBottom: 30 }}>
              We’re sorry. Your tax invoice for rental{" "}
              <strong>{currentRental?.vehicle.registration_number}</strong> is not yet available.
              Please check back at a later date.
            </Typography>
          )}
        </Grid>
      </Grid>
    </Page>
  );
};

export default TaxInvoice;
